import { Component, OnInit, Input } from '@angular/core';
import * as _ from 'lodash';

import { Observable } from 'rxjs/Observable';

import { AccountService } from '../../services/account.service';
import { ConfigService } from '../../services/config.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { GmailService } from '../../services/gmail.service';
import { O365Service } from '../../services/o365.service';
import { SessionService } from '../../services/session2.service';
import { GlobalMessageService } from '../../services/global-message.service';
import { DriftService } from '../../services/drift.service';
import { EmailCampaignService } from '../../services/email-campaign.service';
import { DriftBotInboxService } from '../../services/drift-bot-inbox.service';

import { ConfirmDialogComponent } from '../../global/confirm-dialog/confirm-dialog.component';
import { AlertDialogComponent } from '../../global/alert-dialog/alert-dialog.component';

import { Constants, Partner } from '../../global/constants';
import { PartnerList } from '../../global/models';
import { PartnerPickerOptions } from '../../global/partner-picker/partner-picker.component';

@Component({
  selector: 'app-settings-bot',
  templateUrl: './settings-bot.component.html',
  styleUrls: ['./settings-bot.component.scss'],
})
export class SettingsBotComponent implements OnInit {

  loadingPage: boolean = true;

  inboxes: any[] = [];

  gmailConfig: any = {};
  o365Config: any = {};

  emailBlur: boolean = false;

  inboxNameDialogRef: BsModalRef;
  selectedInbox: any = null;
  newName: string = '';

  // Drift bot inbox
  showAddDriftBotInboxButton: boolean = true;
  botNameValue: string;
  botUserNameValue: string;
  verifiedDomains: any[];
  @Input()
  botDomainValue: string;

  emailsThroughDrift: boolean = false;
  // Set selected partner and list
  selectedPartner: Partner;
  selectedList: PartnerList;
  partnerOptions: PartnerPickerOptions = {
    selectDefaultWhenOne: true
  };

  initialBccEmailAddress: string;
  bccEmailAddress: string;
  showBccEmailWarning: boolean = false;

  constructor(private accountService: AccountService,
              private configService: ConfigService,
              private modalService: BsModalService,
              private cacheService: CacheService,
              private sessionService: SessionService,
              private driftService: DriftService,
              private globalMessageService: GlobalMessageService,
              private gmailService: GmailService,
              private o365Service: O365Service,
              private constants: Constants,
              private emailCampaignService: EmailCampaignService,
              private driftBotInboxService: DriftBotInboxService) { }

  ngOnInit() {
    if (!this.cacheService.get('session')) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.initView();
        }
      )
    }
    else {
      this.initView();
    }
  }

  authGmail() {
    let state = encodeURIComponent('{"email":"direct"}');
    var url = `${this.gmailConfig.authUrl}?` +
              `response_type=code&prompt=consent&access_type=offline&` +
              `client_id=${this.gmailConfig.clientId}&` +
              `redirect_uri=${this.gmailConfig.redirectUrlBot}&` +
              `scope=${this.gmailConfig.scopesBot}&state=${state}`;
    window.location.href = url;
  }

  authO365() {
    let state = encodeURIComponent('{"email":"direct"}');
    var url = `${this.o365Config.authUrl}?` +
              `response_type=code&response_mode=query&` +
              `client_id=${this.o365Config.clientIdBot}&` +
              `redirect_uri=${this.o365Config.redirectUrlBot}&` +
              `scope=${encodeURIComponent(this.o365Config.scopesBot)}&state=${state}`;
    window.location.href = url;
  }

  delete(inbox) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        header: `Delete this connected bot?`,
        message: `Are you sure you want to delete the bot sync for ${inbox.email_address}? This will stop Drift Email from processing future replies but past data will remain in your account.`,
        confirmBtn: 'Delete',
        confirm: function() {
          me.accountService.deleteInbox(inbox._id).subscribe(
            (result: any) => {
              me.driftService.track('deleted-inbox', {email: inbox.email_address});
              me.globalMessageService.message('Bot was deleted');
              me.initView();
            },
            error => {
            }
          );
        }
      }
    }));
  }

  changeName(dialog: any, inbox: any) {
    this.selectedInbox = inbox;
    this.newName = inbox.name;
    this.inboxNameDialogRef = this.modalService.show(dialog, {class: 'modal-md'});
  }

  changePartner(partner: Partner) {
    this.selectedPartner = partner;
    this.selectedList = null;
    // update unsub tracking when partner is cleared
    if (_.isNil(partner)) {
      this.updateUnsubTracking();
    }
  }

  changeList(list: PartnerList) {
    this.selectedList = list;
    // update unsub tracking if partner and list selected
    if (!_.isNil(list)) {
      this.updateUnsubTracking();
    }
  }

  updateUnsubTracking() {
    const update: any = {
      'integration.unsub_tracking': {
        partner: _.get(this.selectedPartner, ['name'], null),
        list: this.selectedList
      }
    };

    this.accountService.updateAccount(update).subscribe(
      (result: any) => {
        this.initView();
        this.globalMessageService.message('Updated unsubscribe tracking');
      }, (err) => {
        this.globalMessageService.error();
        throw err;
      }
    );
  }

  saveName() {
    this.inboxNameDialogRef.hide();
    this.accountService.renameInbox(this.selectedInbox._id, this.newName).subscribe(
      (result: any) => {
        this.initView();
        this.globalMessageService.message('Updated inbox name');
      },
      e => {
        this.globalMessageService.error();
      }
    )
  }

  test(inbox) {
    if (inbox.type == "gmail") {
      this.gmailService.testAccess(inbox._id).subscribe(
        (result: any) => {
          this.modalService.show(AlertDialogComponent, Object.assign({}, {
            initialState: {
              message: `This inbox connection is working.`,
              confirmBtn: 'Close'
            }
          }));
        },
        (error) => {
          const errorMessage = error.error.results.message;
          const displayError = errorMessage.includes('invalid_grant') ? 'Invalid grant - Check settings in Gmail to see that Drift Email has access.' : errorMessage;
          this.modalService.show(AlertDialogComponent, Object.assign({}, {
            initialState: {
              message: `This inbox connection is broken.`,
              confirmBtn: 'Close',
              moreInfoText: `Error: ${displayError}`
            }
          }));
        }
      );
    }
    else {
      this.o365Service.testAccess(inbox._id).subscribe(
        (result: any) => {
          this.modalService.show(AlertDialogComponent, Object.assign({}, {
            initialState: {
              message: `This inbox connection is working.`,
              confirmBtn: 'Close'
            }
          }));
        },
        (error) => {
          const errorMessage = error.error.results.message;
          const displayError = errorMessage.includes('invalid_grant') ? 'Invalid grant - Check settings in your O365 account to see that Drift Email has access.' : errorMessage;
          this.modalService.show(AlertDialogComponent, Object.assign({}, {
            initialState: {
              message: `This inbox connection is broken.`,
              confirmBtn: 'Close',
              moreInfoText: `Error: ${displayError}`
            }
          }));
        }
      )
    }
  }

  resetBotValues() {
    this.botNameValue = "";
    this.botUserNameValue = "";
    if (this.verifiedDomains.length > 0) {
      this.botDomainValue = this.verifiedDomains[0].value;
    }
  }

  toggleShowAddDriftBotInboxButton() {
    this.showAddDriftBotInboxButton = !this.showAddDriftBotInboxButton;
    if (this.showAddDriftBotInboxButton) {
      this.resetBotValues();
    }
  }

  addDriftBotInbox() {
    let me = this;
    const botEmailAddress = this.botUserNameValue + "@" + this.botDomainValue
    this.driftBotInboxService.createDriftBotInbox(this.botNameValue, botEmailAddress).subscribe(
      (result: any) => {
        me.globalMessageService.message('Bot successfully added');
        me.initView();
      },
      (error) => {
        me.globalMessageService.error();
        this.resetBotValues();
      }
    )
    this.showAddDriftBotInboxButton = true;
  }

  changeDomain(domain) {
    this.botDomainValue = domain.value
  }

  saveBccAddress(isValidEmail: boolean) {
    if (isValidEmail || this.bccEmailAddress == "") {
      this.showBccEmailWarning = false;
      this.updateOrDeleteBccAddress();
    } else {
      this.showBccEmailWarning = true;
    }
  }

  updateOrDeleteBccAddress() {
    let me = this;
    if (!!this.bccEmailAddress) {
      this.emailCampaignService.updateBccTrackingEmail(this.bccEmailAddress).subscribe(
        (result: any) => {
          me.globalMessageService.message('BCC address saved');
        },
        (error) => {
          me.globalMessageService.error();
        }
      )
    } else {
      this.emailCampaignService.deleteBccTrackingEmail().subscribe(
        (result: any) => {
          me.globalMessageService.message('BCC address removed');
        },
        (error) => {
          me.globalMessageService.error();
        }
      )
    }
  }

  cancelBccAddress() {
    this.showBccEmailWarning = false;
    this.bccEmailAddress = this.initialBccEmailAddress;
  }

  initEmailCampaigns() {
    Observable.forkJoin(
      this.accountService.getAccount(),
      this.emailCampaignService.getVerifiedSendingDomains(),
      this.emailCampaignService.getBccTrackingEmail()
    ).subscribe(
      (result:any) => {
      const driftEmailDomains = [];
      const driftChatDomains = [];
      result[0].domains.forEach(domain => {
        driftEmailDomains.push(domain.domain)
      });
      result[1].forEach(domain => {
        driftChatDomains.push(domain.domain)
      });
      const verifiedDomains = _.intersection(driftEmailDomains, driftChatDomains)
      this.verifiedDomains = []
      verifiedDomains.forEach(domain => {
        this.verifiedDomains.push({
          label: domain,
          value: domain
        });
      });
      this.resetBotValues();
      this.initialBccEmailAddress = result[2];
      this.bccEmailAddress = result[2];
      this.loadingPage = false;
      },
      error => {
      }
    )
  }

  private initView() {
      this.loadingPage = true;
      Observable.forkJoin(
        this.accountService.getBots(),
        this.configService.gmailConfig(),
        this.configService.o365Config(),
        this.accountService.getIntegrations(),
        this.sessionService.getSession(),
      ).subscribe(
        (result: any) => {
          this.inboxes = result[0];
          this.gmailConfig = result[1];
          this.o365Config = result[2];

          // init unsubscribe tracking
          const integrations = result[3];
          const selectedPartnerName = _.get(integrations, ['unsub_tracking', 'partner'], null);
          this.selectedPartner = selectedPartnerName ? this.constants.partners.find((partner) => partner.name === selectedPartnerName) : null;
          this.selectedList = _.get(integrations, ['unsub_tracking', 'list'], null);
          this.emailsThroughDrift = _.get(result[4], ['f', 'emailsThroughDrift'], false);
          if (this.emailsThroughDrift) {
            this.initEmailCampaigns()
          } else {
            this.loadingPage = false;
          }
        },
        error => {
        }
      )
  }
}



// WEBPACK FOOTER //
// ./client/app/settings/settings-bot/settings-bot.component.ts